import React from "react";
import { Link } from "react-router-dom";
import { Zap, Phone, Mail } from "lucide-react";

export default function TopBar() {
  return (
    <div className="hidden md:flex items-center justify-end px-6 py-2 z-[60] fixed top-0 w-full"
      style={{ background: "#050508", borderBottom: "1px solid rgba(255,255,255,0.05)" }}>
      
      {/* Contact info aligned to right */}
      <div className="flex items-center gap-6 text-xs font-outfit text-gray-400">
        <a href="tel:+919873385555" className="flex items-center gap-1.5 hover:text-white transition-colors no-underline">
          <Phone size={12} /> +91 9873385555
        </a>
        <a href="mailto:info@indiacloud.ai" className="flex items-center gap-1.5 hover:text-white transition-colors no-underline">
          <Mail size={12} /> info@indiacloud.ai
        </a>
      </div>
    </div>
  );
}
